import { useUser } from "@/zustand/store";
import { ChevronRight } from "lucide-react";

const ContactUs = () => {
  const { user } = useUser();
  const openTelegram = () => {
    window.open("https://t.me/PAYG8_LTD", "_blank", "noopener,noreferrer");
  };
  // const openEmail = () => {
  //   window.open("mailto:Support@mpcard.io", "_blank", "noopener,noreferrer");
  // };
  return (
    <div>
      <h3 className="text-dark-primary-400 text-2xl">
        Hello {user?.firstName}, 👋🏻
      </h3>
      <h3 className="text-dark-text-100 text-2xl">How can we help you?</h3>

      <div className="mt-4">
        <div className="rounded-lg px-3 py-3">
          <div
            // No support email address yet — row stays inert until one is supplied
            className="flex w-full items-center justify-between py-4 text-sm hover:cursor-pointer"
          >
            <div className="flex items-center gap-4">
              <img className="size-7" src="/icons/send-email.svg" alt="2fa" />
              <span className="text-dark-text-100">Send an Email</span>
            </div>
            <ChevronRight size={20} className="text-dark-primary-main" />
          </div>
          <div className="border-dark-background-light border-t" />
          <div
            onClick={openTelegram}
            className="flex w-full items-center justify-between py-4 text-sm hover:cursor-pointer"
          >
            <div className="flex items-center gap-4">
              <img
                className="size-7"
                src="/icons/send-telegram.svg"
                alt="2fa"
              />
              <span className="text-dark-text-100">
                Send an Telegram Message
              </span>
            </div>
            <ChevronRight size={20} className="text-dark-primary-main" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
